import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './Footer.css';

class Footer extends Component {
	render() {
		return (
			<Grid item xs={12} id='footer'>
				<Grid container>
					<Grid item xs={12}>
						<p><small>Radio gaga srl - Via Tripolitania 191-193  00199 ROMA - P.IVA/CF  10259821006 - REA 1222300 - C.S. 10.000 Euro - PEC radiogaga@pec.it</small></p>
						<p><small>Credits <a href='mailto:francesca.bassi.84@gmail.com'>Francesca Bassi</a></small></p>
					</Grid>
				</Grid>
			</Grid>
		);
	}
}

export default Footer;